module.exports = __webpack_public_path__ + "media/images/logo-00fafb54d25a5d74325a93abbeb19017.png";